import React, { useEffect, useState, useContext } from "react";
import "../header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { activateFreeTrialService, expireFreeTrialService } from '../services/Evaluation';
import { AuthContext } from "../Hook/AuthProvider";
import {
  getProfile
} from "../services/authenticationServices";
function Header(props) {
  const { profileData, fetchProfile, isAuthenticated } = useContext(AuthContext);
  const [loader, setLoader] = useState(false)
  const [closeModal, setCloseModal] = useState(false);

  const [trailedate, setTrailedate] = useState("");



  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (props.message && props.message[0]?.message) {
      document.title = props.message[0].message;
    }
  }, [props.message]);


  const activateFreeTrial = async () => {
    setLoader(true)
    try {
      // const data = await expireFreeTrialService();
      const response = await activateFreeTrialService();

    } catch (error) {
      console.error("Free trial activation failed:", error);
    }
    finally {
      fetchProfile();
      setLoader(false);
      setCloseModal(false);
    }
  };

  return (
    <div className="header-div">
      <div className="div-left-header">
        <img src="/assets/images/logo/SVG/Logo-Org.svg" alt="Yooki" className="header-logo" />
      </div>
      <div className="mobile-view-only">
        <img src="/assets/images/Vector.svg" alt="Menu" onClick={props.Check} />
      </div>
      <div className="div-center-header">
        <span className="text-center-header">
          {props.message?.[0]?.message
            ? props.message[0].message
                .replace(/<[^>]+>/g, "")
                .split(" ")
                .slice(0, 5)
                .join(" ") +
              (props.message[0]?.message.replace(/<[^>]+>/g, "").split(" ").length > 5
                ? "..."
                : "")
            : location.pathname === "/dashboard"
            ? "Dashboard"
            : ""}
        </span>
        <span className="text-center-header">
          {props.type === "commingsoon" ? (
            <div className="button-premium-header">
              <span>Coming Soon</span>
            </div>
          ) : (
            <div></div>
          )}
        </span>
      </div>
      <div className="right-header-div">
        {(!profileData?.trial_flag && profileData?.user_type !== "pro") && (
          <div
            className="but-trial"
            onClick={() => {
              setCloseModal(true);
            }}
          >
            <span>Start 7 Days Free Trial</span>
          </div>
        )}

        <button className="upgrade-but" onClick={() => navigate("/Price")}>
          {profileData?.user_type === "pro" ? "Extend Pro" : "Upgrade"}{" "}
          <img src="/assets/images/lightening.svg" alt="" />
        </button>
      </div>

      {closeModal && (
        <div className="modal-overlay-header">
          <div class="modal-open">
            <div className="model-open-img">
              <svg
                width="549"
                height="259"
                viewBox="0 0 549 259"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="-0.5"
                  width="549"
                  height="159.537"
                  fill="url(#paint0_linear_0_1)"
                />
                <g filter="url(#filter0_i_0_1)">
                  <path
                    d="M232.873 111.932L60.6523 -0.5H204.401L261.808 111.932H232.873Z"
                    fill="white"
                    fill-opacity="0.22"
                  />
                </g>
                <g filter="url(#filter1_i_0_1)">
                  <path
                    d="M317.131 111.932L489.352 -0.5H345.603L288.196 111.932H317.131Z"
                    fill="white"
                    fill-opacity="0.22"
                  />
                </g>
                <path
                  d="M260.068 108.563L204.449 0.375H344.838L290.27 108.563H260.068Z"
                  fill="white"
                  fill-opacity="0.46"
                />
                <ellipse
                  cx="95.5733"
                  cy="151.268"
                  rx="45.7979"
                  ry="42.7129"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="181.586"
                  cy="133.577"
                  rx="58.2341"
                  ry="54.3113"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="-4.82944"
                  cy="151.267"
                  rx="77.2018"
                  ry="72.0013"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="238.898"
                  cy="177.963"
                  rx="68.5499"
                  ry="63.9322"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="307.448"
                  cy="194.104"
                  rx="68.5499"
                  ry="63.9322"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="562.921"
                  cy="157.479"
                  rx="45.7979"
                  ry="42.7129"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="367.009"
                  cy="154.066"
                  rx="42.9269"
                  ry="40.0352"
                  fill="#FAFAFA"
                />
                <ellipse
                  cx="462.518"
                  cy="157.478"
                  rx="77.2018"
                  ry="72.0013"
                  fill="#FAFAFA"
                />
                <defs>
                  <filter
                    id="filter0_i_0_1"
                    x="60.6523"
                    y="-5.5"
                    width="201.154"
                    height="117.43"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="-5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_0_1"
                    />
                  </filter>
                  <filter
                    id="filter1_i_0_1"
                    x="288.197"
                    y="-5.5"
                    width="201.154"
                    height="117.43"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="-5" />
                    <feGaussianBlur stdDeviation="5" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_0_1"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_0_1"
                    x1="258.747"
                    y1="190.684"
                    x2="255.187"
                    y2="-26.0214"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#37A7D5" />
                    <stop offset="1" stopColor="#F99710" />
                  </linearGradient>
                </defs>
              </svg>
              <div className="calender-model">
                <img src="/assets/images/cal.svg" alt="" />
              </div>
              <div
                className="close-icon-trailmodel"
                onClick={() => {
                  setCloseModal(false);
                }}
              >
                <img src="/assets/images/close-icon-model.svg" alt="" />
              </div>
            </div>
            <div className="secon-text-div">
              <span className="secon-text-div-hed">
                Try PRO FREE for 7 Days?
              </span>
              <span className="secon-text-div-para">
                Explore every premium tool for free. No payment, Start now or
                continue with the free plan.
              </span>
            </div>
            <div className="third-text-div">
              <span className="third-text-div-txt-para">What you’ll get :</span>
              <span className="third-text-div-txt">
                <img src="/assets/images/head-4-img-pop.svg" alt="" />
                Unlimited AI assistance
              </span>
              <span className="third-text-div-txt">
                <img src="/assets/images/head-2-img-pop.svg" alt="" />
                Curated PYQs & Full-Length Tests
              </span>
              <span className="third-text-div-txt">
                <img src="/assets/images/head-3-img-pop.svg" alt="" />
                Unlimited AI Answer Evaluation
              </span>
              <span className="third-text-div-txt">
                <img src="/assets/images/head-1-img-pop.svg" alt="" />
                Adaptive Planner & Syllabus Tracker
              </span>
            </div>
            <div className="butn-footer-mod" >
              <div className={`button-gar-trail ${loader ? "cursorblock" : " "}`} onClick={() => !loader && activateFreeTrial()}>
                <div className="button-gar-trail-inside">
                  {loader ? <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>      <span
                    class="loader-class-buttonclick"
                    style={{ backgroundColor: "#1db9e9 " }}
                  ></span> Loading...</span> : "Start 7-day Free Trial"}</div>
              </div>
              <div className="remind-later-text" onClick={() => setCloseModal(false)}>
                Remind me later
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Header;
